export class GroupManage { 
    id : number;
    groupCode : string;
    groupName : string;
    isAdmin : boolean;
    isActivity : boolean;
    disEducationAndTrainingFor : number;
    checked : boolean;
    constructor(){
        this.disEducationAndTrainingFor = 1;
        this.isAdmin = true;
        this.isActivity = true;
    }
}